module.exports = "/fast-coin/img/coin_start_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin_start_1.png
// module id = 2382
// module chunks = 5